'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @public
 * @param {Object} props
 *   The properties
 * @param {listenerOnSlide} props.onSlide
 *   Callback when the slide changes
 * @param {listenerOnFragment} props.onFragment
 *   Callback when the fragmnet changes
 * @param {number} props.slideCount
 *   (Injected via Dekk)
 * @param {number} props.slideIndex
 *   (Injected via Dekk)
 * @param {number} props.fragmentCount
 *   (Injected via Dekk)
 * @param {number} props.fragmentIndex
 *   (Injected via Dekk)
 * @param {number} props.fragmentOrder
 *   (Injected via Dekk)
 * @param {function} props.toFragment
 *   (Injected via Dekk)
 * @param {function} props.toSlide
 *   (Injected via Dekk)
 * @param {function} props.toNextFragment
 *   (Injected via Dekk)
 * @param {function} props.toPrevFragment
 *   (Injected via Dekk)
 * @param {function} props.toNextSlide
 *   (Injected via Dekk)
 * @param {function} props.toPrevSlide
 *   (Injected via Dekk)
 * @example
 * import Deck, {Plugins} from '@dekk/deck'
 * import Listener from '@dekk/listener'
 *
 * const handleSlide = (slideIndex, slideCount) => {
 *   // code
 * }
 *
 * const handleFragment = (
 *   slideIndex,
 *   slideCount,
 *   fragmentIndex,
 *   fragmentOrder,
 *   fragmentCount
 * ) => {
 *  // code
 * }
 * export default (
 *   <Deck>
 *     <Plugins>
 *       <Listener onSlide={handleSlide}
 *                 onFragment={handleFragment}/>
 *     </Plugins>
 *   </Deck>
 * )
 */
var Listener = function (_Component) {
  _inherits(Listener, _Component);

  function Listener() {
    _classCallCheck(this, Listener);

    return _possibleConstructorReturn(this, (Listener.__proto__ || Object.getPrototypeOf(Listener)).apply(this, arguments));
  }

  _createClass(Listener, [{
    key: 'componentWillReceiveProps',


    /**
     * @private
     */
    value: function componentWillReceiveProps(_ref) {
      var slideIndex = _ref.slideIndex,
          slideCount = _ref.slideCount,
          fragmentOrder = _ref.fragmentOrder,
          fragmentIndex = _ref.fragmentIndex,
          fragmentCount = _ref.fragmentCount;

      if (this.props.fragmentIndex !== fragmentIndex && typeof fragmentOrder !== 'undefined') {
        this.props.onFragment(slideIndex, slideCount, fragmentIndex, fragmentOrder, fragmentCount);
      } else if (this.props.slideIndex !== slideIndex) {
        this.props.onSlide(slideIndex, slideCount);
      }
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        slideIndex: _propTypes2.default.number,
        slideCount: _propTypes2.default.number,
        fragmentOrder: _propTypes2.default.number,
        fragmentIndex: _propTypes2.default.number,
        fragmentCount: _propTypes2.default.number,
        onSlide: _propTypes2.default.func,
        onFragment: _propTypes2.default.func
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        slideIndex: 0,
        slideCount: 0,
        fragmentOrder: 0,
        fragmentIndex: 0,
        fragmentCount: 0,
        onSlide: function onSlide() {
          return null;
        },
        onFragment: function onFragment() {
          return null;
        }
      };
    }
  }]);

  return Listener;
}(_react.Component);

/**
 * @typedef listenerOnSlide
 * @param {number} slideIndex
 *   Index of the currently active slide
 * @param {number} slideCount
 *   Total number of slides
 */

/**
 * @typedef listenerOnFragment
 * @param {number} slideIndex
 *   Index of the currently active slide
 * @param {number} slideCount
 *   Total number of slides
 * @param {number} fragmentIndex
 *   Index of the currently active fragment
 * @param {number} fragmentOrder
 *   Order of the currently active fragment
 * @param {number} fragmentCount
 *   Total number of fragments in the currently active slide
 */

exports.default = Listener;